import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import CourseQ from '@/queries/CourseQ'
import { useQuery } from '@/client/context/query'
import { getCourseUrlBySlug } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Tippy from '@/components/UI/Tippy'

const CourseList: React.FC = () => {
  const query = useQuery()

  const courses = query.many(CourseQ.getAll({}))

  return (
    <Accordion
      defaultIndex={[0]}
      allowToggle
      borderBottom={`2px solid ${chakraTokenToVar('border')}`}
    >
      <AccordionItem>
        <Tippy content="Collapse/Uncollapse Courses">
          <AccordionButton
            bgColor="rgba(0, 0, 0, 0)"
            border="none"
            px={0}
            pt={0}
            _hover={{
              cursor: 'pointer',
            }}
            _focus={{
              outline: 'none',
            }}
            flex={1}
            justifyContent="space-between"
          >
            <Heading size="lg" as="h4" mb="6px">
              Courses
            </Heading>
            <AccordionIcon />
          </AccordionButton>
        </Tippy>

        <AccordionPanel maxH="calc(100vh - 244px)" overflowY="auto" p={0}>
          {/* Subtract combined height of Nav header, Topics title, and Type filter */}
          <VStack align="start" spacing={0}>
            {courses.map(entry => (
              <ShwLink
                key={entry(CourseQ.id) ?? 0}
                href={getCourseUrlBySlug(`${entry(CourseQ.slug)}`)}
                width="100%"
              >
                <Box
                  width="100%"
                  py="8px"
                  px="24px"
                  borderRadius="4px"
                  _hover={{
                    bgColor: 'bg.muted',
                  }}
                  _active={{
                    bgColor: 'bg.muted',
                  }}
                  textDecoration="none"
                  color="fg"
                >
                  <Text as="span"> {entry(CourseQ.name)}</Text>
                </Box>
              </ShwLink>
            ))}
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default CourseList
